import styled, { css } from 'styled-components';

const RootStyled = styled.div`
  gap: 32px;
`;

const TitleStyled = styled.div<{ minimized?: boolean }>`
  ${({ theme }) => theme.typography.body1};
  color: ${({ theme }) => theme.colors.neutral.onBackground};

  margin: 44px 32px;
  ${({ minimized }) =>
    minimized &&
    css`
      margin-left: 0;
    `};
`;

export type JourneyViewListCardEmptyStateProps = {
  title: string;
  minimized?: boolean;
};

export const JourneyViewListCardEmptyState = ({ title, minimized }: JourneyViewListCardEmptyStateProps): JSX.Element => {
  return (
    <RootStyled>
      <TitleStyled minimized={minimized}>{title}</TitleStyled>
    </RootStyled>
  );
};
